import React, {useState, useRef, useEffect, MutableRefObject} from 'react';
import './accordion.scss'
import {Panel} from 'models';


interface Props {
    panels: Panel[]
}

interface PanelProps {
    name: string,
    description: string,
    activeTab: number,
    index: number,
    activateTab: (index: number) => any
    image: any;
}

export const Accordion: React.FC<Props> = ({panels}) => {
    const [activeTab, setActiveTab] = useState<number>(0)

    const activateTab = (index: any) => {
        activeTab === index ? setActiveTab(-1) : setActiveTab(index)
    }

    return (
        <div className='accordion'>
            {panels.map(({id, name, description, image}, index) =>
                <AccordionPanel
                    key={id}
                    activeTab={activeTab}
                    index={index}
                    name={name}
                    image={image}
                    description={description}
                    activateTab={activateTab}
                />
            )}
        </div>
    );
}


const AccordionPanel: React.FC<PanelProps> = ({name, description, activeTab, index, activateTab, image}) => {

    const bodyRef = useRef() as MutableRefObject<HTMLDivElement>;

    const [height, setHeight] = useState<number>(0);

    const isActive = activeTab === index;

    useEffect(() => {
        setHeight(bodyRef.current.scrollHeight)
    }, [isActive])

    return (
        <div className='panel' aria-expanded={isActive}>
            <div className='panel__label'
                 role='tab'
                 onClick={() => activateTab(index)}>
                <img src={image} alt=""/>
                <span>{name}</span>
            </div>
            <div className='panel__inner'
                 style={{height: `${isActive ? height : 0}px`}}
                 ref={bodyRef}
                 aria-hidden={!isActive}>
                <div className='panel__inner__content'>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
}

// export default Accordion;